export enum StateOfFish {
    NotSet = 0,
    Alive = 1,
    Cooled = 2,
    Melted = 3,
    Frozen = 4
}

(StateOfFish as any).__typeName = 'StateOfFish';
